<template>
  <div class="col-3">
    <!-- <p>Das Fachplanungsbüro erarbeitet mit dem Stadtplanungsamt derzeit aus der Summe der Bürgerbeteiligung, den Ergebnissen der Arbeitsgruppe den Leitbildentwurf, der Ende Herbst im Planungsausschuss präsentiert wird.</p> -->
    <!-- <p>Das Fachplanungsbüro erarbeitet mit dem Stadtplanungsamt derzeit auf der Grundlage der Bürgerbeteiligung und der Ergebnisse der Arbeitsgruppe den Leitbildentwurf. Dieser wird Ende Herbst im Planungsausschuss präsentiert.</p> -->
    <p>Der Bau-und Planungsausschuss hatte den Leitbildentwurf am 20.11.2019 vorberaten. Entsprechende Änderungen wurden in roter Schrift mit den Abstimmungsergebnissen eingetragen. Der Stadtrat hat am 10.12.2019 diesen Bericht als Räumliches Leitbild einstimmig beschlossen. Das Ergebnis dient dem Flächennutzungsplan, der ab 2020 neu aufgestellt wird.</p>
    <p>
      Den Bericht zum Download als PDF finden Sie
      <router-link to="/projekt/downloads">hier</router-link>.
    </p>
    <img :src="require('@/assets/fotos/leitbild/leitbild.png')" style="width: 100%" alt="leitbild" />
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: "Leitbildentwurf"
  }
};
</script>

<style lang="scss" scoped>
</style>